(() => {
  'use strict';
  const bind = () => {
    const form = document.getElementById('r2-filters');
    if (!form || form.dataset.bound) return;
    const grid = document.getElementById('r2-catalog-grid');
    if (!grid) return;
    form.dataset.bound = 'true';
    // The original DOM order is the collection's featured order, including ties.
    const cards = [...grid.querySelectorAll('.card')];
    const order = new Map(cards.map((card, index) => [card, index]));
    const q = document.getElementById('r2-q');
    const color = document.getElementById('r2-color');
    const occasion = document.getElementById('r2-occasion');
    const shape = document.getElementById('r2-form') || document.getElementById('r2-shape');
    const flower = document.getElementById('r2-flower');
    const budget = document.getElementById('r2-budget');
    const budgetError = document.getElementById('r2-budget-error');
    const sort = document.getElementById('r2-sort');
    const count = document.getElementById('r2-result-count');
    const empty = document.getElementById('r2-empty');
    const tokens = value => (value || '').split(/\s+/).filter(Boolean);
    const normalizeColor = value => value === 'lilac' ? 'purple' : value;
    const valueOf = field => field ? field.value : '';
    const selected = field => field ? [...field.selectedOptions].map(option => option.value).filter(Boolean) : [];
    const setSelected = (field, values) => {
      if (!field) return;
      const wanted = new Set(values.filter(Boolean));
      [...field.options].forEach(option => { option.selected = option.value ? wanted.has(option.value) : wanted.size === 0; });
    };
    const budgetAmount = () => {
      const raw = budget?.value.trim() || '';
      return /^\d{1,9}(?:\.\d{1,2})?$/.test(raw) ? Math.round(Number(raw) * 100) : null;
    };
    const shapeValues = ['bouquet', 'tabletop', 'vase_arrangement', 'potted_arrangement', 'single_stem'];
    const shapeMatches = (card, value) => !value || card.dataset.form === value
      || (value === 'tabletop' && ['vase_arrangement', 'potted_arrangement'].includes(card.dataset.form));
    const colourValues = [...new Set(cards.flatMap(card => tokens(card.dataset.color).map(normalizeColor)))];
    const flowerValues = [...new Set(cards.flatMap(card => tokens(card.dataset.flower)))].sort();
    [color, flower].filter(Boolean).forEach(field => { field.multiple = true; });
    if (flower) {
      flowerValues.forEach(value => {
        if ([...flower.options].some(option => option.value === value)) return;
        const option = document.createElement('option');
        option.value = value;
        option.textContent = value.replace(/_/g, ' ').replace(/(^|\s)\S/g, char => char.toUpperCase());
        flower.appendChild(option);
      });
      // Only the backend control is ours to hide; a label can contain visible UI.
      flower.hidden = true;
    }
    const sortValues = ['featured', 'price-ascending', 'price-descending', 'title-ascending'];
    const priceOf = card => {
      // Unknown/inquiry prices never become zero or pass an active budget.
      if (card.dataset.kind === 'inquiry' || card.dataset.readiness === 'held') return null;
      const raw = card.getAttribute('data-price');
      if (raw === null || !/^\d+$/.test(raw)) return null;
      const number = Number(raw);
      return Number.isSafeInteger(number) ? number : null;
    };
    function restore() {
      const params = new URLSearchParams(location.hash.slice(1));
      if (q) q.value = params.get('q') || '';
      const restoreMulti = (field, key, normalize = value => value) => {
        if (!field) return;
        const available = new Set([...field.options].map(option => option.value));
        setSelected(field, (params.get(key) || '').split(',').map(normalize).filter(value => available.has(value)));
      };
      restoreMulti(color, 'color', normalizeColor);
      restoreMulti(flower, 'flower');
      if (occasion) occasion.value = ['graduation', 'christmas'].includes(params.get('occasion')) ? params.get('occasion') : '';
      if (shape) shape.value = shapeValues.includes(params.get('form')) ? params.get('form') : '';
      if (sort) sort.value = sortValues.includes(params.get('sort')) ? params.get('sort') : 'featured';
      if (budget) {
        const sameCurrency = params.get('currency') === budget.dataset.currency;
        budget.value = sameCurrency && /^\d{1,9}(?:\.\d{1,2})?$/.test(params.get('max') || '') ? params.get('max') : '';
        if (params.has('max') && !budget.value) {
          params.delete('max'); params.delete('currency');
          history.replaceState(null, '', location.pathname + location.search + (params.size ? '#' + params.toString() : ''));
        }
      }
    }
    function apply(update = true) {
      const query = valueOf(q).trim().toLowerCase();
      const colours = selected(color).map(normalizeColor);
      const flowers = selected(flower);
      setSelected(color, colours);
      setSelected(flower, flowers);
      const maximum = budgetAmount();
      const invalidBudget = !!budget?.value.trim() && maximum === null;
      if (budgetError) budgetError.hidden = !invalidBudget;
      budget?.setAttribute('aria-invalid', String(invalidBudget));
      const matchesFacet = (card, ignore = '') =>
        (ignore === 'colour' || !colours.length || tokens(card.dataset.color).map(normalizeColor).some(value => colours.includes(value)))
        && (!valueOf(occasion) || card.dataset.occasion === valueOf(occasion))
        && (maximum === null || (priceOf(card) !== null && priceOf(card) <= maximum))
        && (ignore === 'shape' || shapeMatches(card, valueOf(shape)))
        && (ignore === 'flower' || !flowers.length || tokens(card.dataset.flower).some(value => flowers.includes(value)))
        && (!query || (card.dataset.search || '').toLowerCase().includes(query));
      let matches = 0;
      for (const card of cards) {
        card.hidden = !matchesFacet(card);
        if (!card.hidden) matches++;
      }
      // Each facet counts the remaining constraints, so alternatives stay usable.
      const countsFor = (facet, values, hasValue) => {
        const candidates = cards.filter(card => matchesFacet(card, facet));
        return Object.fromEntries([['', candidates.length], ...values.map(value => [value, candidates.filter(card => hasValue(card, value)).length])]);
      };
      const colourCounts = countsFor('colour', [...new Set([...colourValues, ...[...(color?.options || [])].map(option => option.value).filter(Boolean)])],
        (card, value) => tokens(card.dataset.color).map(normalizeColor).includes(value));
      const flowerCounts = countsFor('flower', [...new Set([...flowerValues, ...[...(flower?.options || [])].map(option => option.value).filter(Boolean)])],
        (card, value) => tokens(card.dataset.flower).includes(value));
      const shapeCounts = countsFor('shape', shapeValues, shapeMatches);
      [[color, colourCounts, colours.length ? colours : ['']], [flower, flowerCounts, flowers.length ? flowers : ['']], [shape, shapeCounts, [valueOf(shape)]]].forEach(([field, counts, active]) => {
        if (field) [...field.options].forEach(option => {
          option.disabled = (counts[option.value] || 0) === 0 && !active.includes(option.value);
        });
      });
      const updateButtons = (selector, key, counts, active) => {
        form.querySelectorAll(selector).forEach(button => {
          const raw = button.dataset[key] || '';
          const value = raw === 'all' ? '' : raw;
          const available = counts[value] || 0;
          button.dataset.count = String(available);
          button.disabled = available === 0 && !active.includes(value);
          let label = button.querySelector('[data-option-count]');
          if (!label) {
            label = document.createElement('span');
            label.setAttribute('data-option-count', '');
            button.appendChild(label);
          }
          label.textContent = ' (' + available + ')';
        });
      };
      updateButtons('[data-pixel-colour]', 'pixelColour', colourCounts, colours.length ? colours : ['']);
      updateButtons('[data-pixel-flower]', 'pixelFlower', flowerCounts, flowers.length ? flowers : ['']);
      updateButtons('[data-pixel-shape]', 'pixelShape', shapeCounts, [valueOf(shape)]);
      const mode = valueOf(sort) || 'featured';
      const sorted = [...cards].sort((a, b) => {
        const aPrice = priceOf(a), bPrice = priceOf(b);
        if (mode.startsWith('price-') && (aPrice === null) !== (bPrice === null)) return aPrice === null ? 1 : -1;
        let difference = 0;
        if (aPrice !== null && bPrice !== null && mode.startsWith('price-')) {
          difference = mode === 'price-ascending' ? aPrice - bPrice : bPrice - aPrice;
        } else if (mode === 'title-ascending') {
          difference = (a.dataset.title || '').localeCompare(b.dataset.title || '', 'en', { sensitivity: 'base' });
        }
        return difference || order.get(a) - order.get(b);
      });
      const fragment = document.createDocumentFragment();
      sorted.forEach(card => fragment.appendChild(card));
      grid.appendChild(fragment);
      if (count) count.textContent = matches + ' product' + (matches === 1 ? '' : 's');
      if (empty) empty.hidden = matches > 0;
      if (update) {
        const params = new URLSearchParams();
        if (query) params.set('q', query);
        if (colours.length) params.set('color', colours.join(','));
        if (valueOf(occasion)) params.set('occasion', occasion.value);
        if (valueOf(shape)) params.set('form', shape.value);
        if (flowers.length) params.set('flower', flowers.join(','));
        if (mode !== 'featured') params.set('sort', mode);
        if (maximum !== null) { params.set('max', budget.value.trim()); params.set('currency', budget.dataset.currency); }
        history.replaceState(null, '', location.pathname + location.search + (params.size ? '#' + params.toString() : ''));
      }
      form.dispatchEvent(new CustomEvent('pixel:catalog-updated', {
        bubbles: true, detail: { matches, total: cards.length, colourCounts, flowerCounts, shapeCounts }
      }));
    }
    form.addEventListener('submit', event => { event.preventDefault(); apply(); });
    for (const field of [q, color, occasion, shape, flower, budget, sort].filter(Boolean)) {
      field.addEventListener('input', () => apply());
      field.addEventListener('change', () => apply());
    }
    function clear(event) {
      event.preventDefault();
      if (q) q.value = '';
      setSelected(color, []);
      setSelected(flower, []);
      if (occasion) occasion.value = '';
      if (shape) shape.value = '';
      if (budget) budget.value = '';
      if (sort) sort.value = 'featured';
      apply();
    }
    document.getElementById('r2-reset')?.addEventListener('click', clear);
    document.querySelectorAll('[data-r2-clear]').forEach(link => link.addEventListener('click', clear));
    const navigation = () => { if (form.isConnected) { restore(); apply(false); } };
    window.addEventListener('hashchange', navigation);
    window.addEventListener('popstate', navigation);
    restore();
    apply(false);
    // Expose working controls only after the grid and restored state initialize.
    form.hidden = false;
    document.querySelectorAll('[data-r2-sort-help]').forEach(help => { help.hidden = false; });
  };
  bind();
  document.addEventListener('shopify:section:load', bind);
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.pixel-r2 details[open]').forEach(details => { details.open = false; });
  });
})();
